module.exports = __webpack_public_path__ + "img/icon-62.094825c2.svg";